import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useQueryParams } from '../HelperFunction/Hooks/useQueryParams';
import { useCategoryApi } from '../../Hooks/useCategoryApi';

export const useAllCategory = ({
  isMainScreen = false,
  initialData,
  key,
}: {
  initialData?: any;
  isMainScreen?: boolean;
  key?: any;
}) => {
  const { query, queryhash, setFilters, filters, setQuery, updateQuery } =
    useQueryParams<any>({
      isMainScreen,
      initialData,
    });
  const { getAllCategory } = useCategoryApi();
  const {
    data,
    isLoading: isFetching,
    refetch,
    isRefetching,
  } = useQuery({
    queryKey: ['getCategory', { hasParams: queryhash?.length === 0 }, { key }],
    queryFn: () => {
      return getAllCategory(query);
    },
  });

  useEffect(() => {
    if (queryhash) {
      refetch();
    }
  }, [queryhash]);

  const isLoading = isFetching || isRefetching;

  return {
    data,
    isLoading,
    query,
    setQuery,
    filters,
    setFilters,
    updateQuery,
  };
};
